































































import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
let cookies = [] as Character[];
import * as _cookies from '@/assets/scraper_output/cookies.json';
if ((_cookies as any).default) {
  cookies = (_cookies as any).default; 
}
let rarities = [] as RarityChances[];
import * as _rarities from '@/assets/scraper_output/cookies_rarity.json';
if ((_rarities as any).default) {
  rarities = (_rarities as any).default; 
}
import { Result } from '@/types/Result'
import { Character } from '@/bindings/Character'
import { CharacterType } from '@/bindings/CharacterType';
import { RarityChances } from '@/bindings/RarityChances';
import { directive } from 'vue/types/umd';


@Component({
  components: {

  },
  data() {
    return {
      import :{CharacterData} , from: '../../character.ts',
      popup: false,
      popup2: false    // if you want it to always popup when you first open the page then change to true 
    }
  },
  mounted() {
    
  },
  methods: {
    random() {
      return Math.round(Math.random()* 100000)/1000 // using math.random and getting a number from 1-100000,
    },                                               // rounding it, then divide by 1000 gives us a random number from 1-100 with 3 decimal places 
    roll(amountOfRolls: number = 1) {
      const tmpReturn = new Result();
      const rolls: number[] = [];
      //do this for however many rolls 
      for(let i = 0; i < amountOfRolls; i++){ 
        const something = (this as any).random()
        rolls.push(something);
      };
      //sort from highest to lowest 
      rolls.sort((a:number, b: number) => { 
        return b-a
      })
      // defining an array with the character and its probability 
      const tups: Array<[Character, RarityChances]> = [];
      (cookies as Character[]).forEach((cookie)=> {
        var tup: [Character, RarityChances] = [cookie, (rarities as RarityChances[]).find(e => e.rarity == cookie.rarity)!]
        tups.push(tup)
      })
        rolls.forEach( roll => {
        let sum = 0;
        // get each cookie's rarity 
        (cookies as Character[]).every(cookie => {
          var rarity = {...(rarities as RarityChances[]).find(e => e.rarity == cookie.rarity)!}
        // manipulating cookie chances (boosting a specific character's rates): 
          if(cookie.name === "Cherry Blossom Cookie") {
            rarity.cookie = 1.440
            rarity.soulstone = 8.200
          }
        //adds probabilities of cookies until the random number (roll) falls in the range of that probability 
          sum += rarity.cookie
          if (roll <= sum) {
            tmpReturn.cookies.push(cookie)
            return false;
          }
        //same but for soulstone probability 
          sum += rarity.soulstone
          if (roll <= sum) {
            tmpReturn.soulstones.push(cookie)
            return false;
          }
          return true;
        })
      })
      return tmpReturn;
    }
  },
})

export default class Home extends Vue {}
window.addEventListener('load', function () {
  })
